import {FC} from 'react'
import {RemovedProduct} from '../core/_models'
import RemovedProductsTableRow from './RemovedProductsTableRow'
import {useIntl} from 'react-intl'

interface IProps {
  products: RemovedProduct[]
  onImageClick: (imageUrl: string) => void
}

const RemovedProductsTable: FC<IProps> = ({products, onImageClick}) => {
  const {formatMessage} = useIntl()

  return (
    <>
      <table className='table align-middle gs-0 gy-4 table-row-dashed table-row-gray-300'>
        <thead>
          <tr className='fw-bolder text-muted'>
            <th className='min-w-200px'>{formatMessage({id: 'REMOVED_PRODUCTS.PRODUCT'})}</th>
            <th className='min-w-150px'>{formatMessage({id: 'REMOVED_PRODUCTS.BARCODE'})}</th>
            <th className='min-w-150px'>{formatMessage({id: 'REMOVED_PRODUCTS.MODEL'})}</th>
            <th className='min-w-50px text-center'>{formatMessage({id: 'REMOVED_PRODUCTS.QUANTITY'})}</th>
            <th className='min-w-150px'>{formatMessage({id: 'REMOVED_PRODUCTS.REMOVAL_REASON'})}</th>
            <th className='min-w-100px'>{formatMessage({id: 'REMOVED_PRODUCTS.PO_ID'})}</th>
            <th className='min-w-120px'>{formatMessage({id: 'REMOVED_PRODUCTS.REMOVED_DATE'})}</th>
            <th className='min-w-120px text-center'>{formatMessage({id: 'REMOVED_PRODUCTS.STATUS'})}</th>
            <th className='min-w-150px'>{formatMessage({id: 'REMOVED_PRODUCTS.CONFIRMED_BY'})}</th>
            <th className='min-w-180px'>{formatMessage({id: 'REMOVED_PRODUCTS.CONFIRMED_DATE'})}</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <RemovedProductsTableRow
              key={`removed-product-${product.removed_po_item_id}`}
              product={product}
              onImageClick={onImageClick}
            />
          ))}
        </tbody>
      </table>
    </>
  )
}

export default RemovedProductsTable

